import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotFoundRoutingModule } from './not-found-routing.module';
import { NotFoundComponent } from './component/not-found/not-found.component';
import { NotFoundProxyComponent } from './component/not-found-proxy/not-found-proxy.component';
import { NotFound2Component } from './component/not-found2/not-found2.component';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ShareModule } from '../share/share.module';


@NgModule({
  declarations: [
    NotFoundComponent,
    NotFoundProxyComponent,
    NotFound2Component,
  ],
  imports: [
    CommonModule,
    NotFoundRoutingModule,
    TranslateModule,
    FormsModule,
    MatAutocompleteModule,
    ShareModule,
  ]
})
export class NotFoundModule { }
